import createUploadLink from 'apollo-upload-client/createUploadLink.mjs';
import { ApolloLink } from '@apollo/client';

const GRAPHQL_URL = process.env.REACT_APP_GRAPHQL_URL;

export const uploadLink = createUploadLink({
  uri: GRAPHQL_URL,
  fetch: (uri, options = {}) => {
    options.headers = {
      ...options.headers,
      'apollo-require-preflight': 'true', // This header satisfies Apollo CSRF protection
    };
    return fetch(uri, options);
  },
}) as unknown as ApolloLink;
